// extracted by mini-css-extract-plugin
module.exports = {"favoriteIcon":"favorite-button_favoriteIcon__zQqcn","heartIcon":"favorite-button_heartIcon__sG76m","favorited":"favorite-button_favorited__L9FgZ"};